import { IconProps } from "../../types/utils";

const AccountIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 19.1666C19 19.5656 18.6766 19.8888 18.2778 19.8888C17.8788 19.8888 17.5554 19.5656 17.5554 19.1666C17.5554 16.3744 15.2922 14.1112 12.5 14.1112C9.70784 14.1112 7.44457 16.3745 7.44457 19.1666C7.44457 19.5656 7.12115 19.8888 6.72216 19.8888C6.32341 19.8888 6 19.5656 6 19.1666C6 15.5767 8.9101 12.6666 12.5 12.6666C16.0899 12.6666 19 15.5767 19 19.1666ZM12.5 11.9444C10.3063 11.9444 8.52765 10.1661 8.52765 7.97208C8.52765 5.77834 10.3063 4 12.5 4C14.6938 4 16.4724 5.77834 16.4724 7.97208C16.4724 10.166 14.6938 11.9444 12.5 11.9444ZM12.5 10.5001C13.896 10.5001 15.0277 9.36836 15.0277 7.97215C15.0277 6.5762 13.896 5.44444 12.5 5.44444C11.104 5.44444 9.97229 6.5762 9.97229 7.97215C9.97229 9.36836 11.104 10.5001 12.5 10.5001Z"
      fill={color || "#B3BCC8"}
    />
  </svg>
);

export default AccountIcon;
